import { render, staticRenderFns } from "./BankExpert.vue?vue&type=template&id=129460f5&scoped=true&"
import script from "./BankExpert.vue?vue&type=script&lang=js&"
export * from "./BankExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129460f5",
  null
  
)

export default component.exports